<section
  [class]="
    isEventPage()
      ? 'w-full flex flex-col items-center gap-4 lg:gap-6 px-4 container max-w-7xl lg:py-15 py-6'
      : 'w-full flex flex-col items-center gap-4 lg:gap-6 px-4 container max-w-7xl lg:pb-40 py-6'
  ">
  <img src="/home/title/exhibition-scene.png" alt="Exhibition Scene" class="h-5 lg:h-8 mx-auto object-contain" />
  <h1 class="text-xl text-zinc-800 font-extrabold lg:text-4xl">생생한 박람회 현장 모습</h1>
  <p class="text-sm text-zinc-500 font-medium lg:text-lg">박람회의 모든 현장을 한눈에 담았습니다.</p>

  <div class="relative w-full lg:mx-8">
    @if (photoGalleries().length) {
    <div class="relative">
      <div swiper class="swiper w-full overflow-hidden" (init)="onSwiperInit($event)" [options]="swiperOptions()">
        <div class="swiper-wrapper">
          @for (gallery of photoGalleries(); track gallery.id) {
          <div class="swiper-slide">
            <a [routerLink]="['/customer/gallery', gallery.id]" class="cursor-pointer group block">
              <div class="w-full lg:w-80 h-40 lg:h-56.25 rounded-xl overflow-hidden bg-zinc-200 relative">
                <img [src]="getFirstPhoto(gallery)" [alt]="gallery.title" class="w-full h-full object-cover" />
              </div>
            </a>
          </div>
          }
        </div>
      </div>

      <app-swiper-navigation (prev)="goToPrev()" (next)="goToNext()" />
    </div>
    } @else {
    <app-not-found>
      <p>등록된 사진이 없습니다.</p>
    </app-not-found>
    }
  </div>
</section>
